import { TrackableEntity } from "../../fms.core/data/ChangeTrackable";

export class ReleaseHblInfo  extends TrackableEntity  {
    refNo: string = '';
    branch: string = '';
    mblNo: string = '';
    carrier: string = '';
    hblNo: string = '';
    custName: string = '';
    subBl: string = '';
    pkgs: number = 0;
    podEta: string | null = null;
    kgs: number = 0;
    lbs: number = 0;
    cbm: number = 0;
    cft: number = 0;
    cdtLmt: number|null = null;
    mExpRls: boolean = false;
    pMemo: string = '';
    cfsLoc: string = '';
    cfsDate: string | null = null;
    expRls: boolean = false;
    pror: boolean = false;
    edi: boolean = false;
    oblCol: number = 0;
    oblDate: string | null = null;
    rlsd: boolean = false;
    rlsDate: string | null = null;
    rlsBy: string = '';
    containers: ContainerItem[] = [];
    billItems: BillItem[] = [];
    invoItems: InvoItem[] = [];
    id: number = 0;
    mRlsDate: string | null = null;
    billTo: number|null = null;
    billToName: string = '';
    oiMblId: number = 0;
    cdtHold: boolean = false;
    isfNo: string = '';
    totalBalance: number = 0;
    totalPastDue: number = 0;

    // for cloud
    cfsYn: boolean = false;

    printRelOrder: boolean = false;
    cfsRelOrder: boolean = false;
    releaseOrder: boolean = false;

    rlsBtnEnable: boolean = false;
    rlsBtnText: string = 'Release';
    
    constructor(init?:Partial<ReleaseHblInfo>) {
        super();
        this.key=undefined;
        Object.assign(this, init);
    }
}

export class ContainerItem  {
    containerNo: string = '';
}

export class BillItem  {
    postDate: string = '';
    vendorName: string = '';
    descript: string = '';
    invoiceNo: string = '';
    dueDate: string | null = null;
    billAmt: number = 0;
    paidAmt: number = 0;
    status: string = '';
}

export class InvoItem  {
    invoiceDate: string | null = null;
    invoiceNo: string = '';
    hblNo: string = '';
    overDue: number = 0;
    invoiceAmt: number = 0;
    paidAmt: number = 0;
    balance: number = 0;
    billTo: number = 0;
    id: number = 0;
    flag: boolean = false;
}

